
import { mapState, mapGetters } from "vuex";
import { summaryReportHeader } from "../../constants/Others";
import reportSalesSummary from "./report-sales-summary.vue";
import reportOrderTable from "./report-order-table.vue";
export default {
  components: { reportSalesSummary, reportOrderTable },
  props: {
    printMode: {
      default: false
    }
  },
  data() {
    return {
      titles: summaryReportHeader
    };
  },
  computed: {
    ...mapState("report", ["products", "summary"]),
    ...mapGetters("report", ["getTotalObjForSummaryReport"])
  }
};
